import { LoaderText } from '../../LoaderText'
import {
  useEmailProfileContext,
  useEmailProfileMessagesListExpandContext,
} from '../Email.hooks'
import {
  EmailDraftProvider,
  getDraftProviderPrefix,
} from '../EmailDraftProvider'
import {
  EmailProfileMessage,
  EmailProfileMessageCollapsedHeaderSenderAdditionalInfo,
  EmailProfileMessageSkeleton,
} from '../EmailProfileMessage'

import * as styles from './EmailProfileMessagesList.module.css'

function EmailProfileMessagesList({
  className = styles.EmailProfileMessagesList,
  getMessageThresholdItemsProps,
  itemProps,
  items,
  loadingMore,
}) {
  const { isInitiated } = useEmailProfileContext()

  const { isExpanded, toggleExpandMessage } =
    useEmailProfileMessagesListExpandContext()

  return (
    <>
      <div className={className}>
        {isInitiated && items?.length > 0 ? (
          items.map((message, index) => (
            <EmailDraftProvider
              key={message.uuid || index}
              prefix={getDraftProviderPrefix(message.uuid)}
            >
              <EmailProfileMessage
                {...itemProps}
                {...(index > 0
                  ? {
                      headerProps: {
                        ...itemProps?.headerProps,
                        AdditionalInfo: isExpanded(message.uuid)
                          ? undefined
                          : EmailProfileMessageCollapsedHeaderSenderAdditionalInfo,
                        onClick: toggleExpandMessage,
                      },
                    }
                  : null)}
                {...getMessageThresholdItemsProps?.(index)}
                data={message}
                isExpanded={index === 0 || isExpanded(message.uuid)}
              />
            </EmailDraftProvider>
          ))
        ) : (
          <EmailProfileMessageSkeleton />
        )}
      </div>
      {loadingMore ? <LoaderText /> : null}
    </>
  )
}

export default EmailProfileMessagesList
